import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * 系统中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: true,
          title: '首页',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/single-page/home')
      }
    ]
  },
  {
    path: '/vehicle',
    name: 'vehicle',
    component: Main,
    meta: {
      access: ['admin', 'groupadmin'],
      title: '车辆管理',
      icon: 'ios-people'
    },
    children: [
      {
        path: 'vehicleinfos',
        name: 'vehicleinfos',
        meta: {
          icon: 'md-people',
          title: '车辆信息管理'
        },
        component: () => import('@/view/vehicle-infos')
      },
      // {
      //   path: 'vehicleownerinfos',
      //   name: 'vehicleownerinfos',
      //   meta: {
      //     icon: 'md-people',
      //     title: '车辆所有人管理'
      //   },
      //   component: () => import('@/view/vehicle-owner-infos')
      // },
      {
        path: 'clientinfos',
        name: 'clientinfos',
        meta: {
          icon: 'md-people',
          title: '客户信息管理'
        },
        component: () => import('@/view/clientinfos')
      },
      {
        path: 'vehiclebrands',
        name: 'vehiclebrands',
        meta: {
          icon: 'md-people',
          title: '车辆品牌管理'
        },
        component: () => import('@/view/vehicle-brands')
      }
    ]
  },
  {
    path: '/transport',
    name: 'transport',
    component: Main,
    meta: {
      title: '运输公司管理',
      icon: 'ios-people'
    },
    children: [
      {
        path: 'transportvehicleinfos',
        name: 'transportvehicleinfos',
        meta: {
          access: ['admin', 'groupadmin'],
          icon: 'md-people',
          title: '运输车辆信息管理'
        },
        component: () => import('@/view/transport/transport-vehicle-infos')
      },
      {
        path: 'transportvehicleinfogroups',
        name: 'transportvehicleinfogroups',
        meta: {
          access: ['admin'],
          icon: 'md-people',
          title: '运输车辆信息分组管理'
        },
        component: () => import('@/view/transport/transport-vehicle-info-groups')
      },
      {
        path: 'reminds',
        name: 'reminds',
        meta: {
          access: ['admin', 'groupadmin'],
          icon: 'md-people',
          title: '提醒报表'
        },
        component: () => import('@/view/transport/reminds')
      },
      {
        path: 'peccancyrecords',
        name: 'peccancyrecords',
        meta: {
          access: ['admin', 'groupadmin'],
          icon: 'md-people',
          title: '违章报表'
        },
        component: () => import('@/view/transport/peccancy-records')
      }
    ]
  },
  {
    path: '/acl',
    name: 'acl',
    component: Main,
    meta: {
      access: ['admin', 'groupadmin'],
      title: '用户权限管理',
      icon: 'ios-people'
    },
    children: [
      {
        path: 'users',
        name: 'users',
        meta: {
          access: ['admin', 'groupadmin'],
          icon: 'md-people',
          title: '用户管理'
        },
        component: () => import('@/view/acl/users')
      },
      {
        path: 'clients',
        name: 'clients',
        meta: {
          access: ['admin'],
          icon: 'md-people',
          title: '分组管理员管理'
        },
        component: () => import('@/view/acl/clients')
      },
      {
        path: 'usergroups',
        name: 'usergroups',
        meta: {
          access: ['admin', 'groupadmin'],
          icon: 'md-people',
          title: '用户分组管理'
        },
        component: () => import('@/view/acl/user-groups')
      },
      {
        path: 'roles',
        name: 'roles',
        meta: {
          access: ['admin'],
          icon: 'md-ribbon',
          title: '角色管理'
        },
        component: () => import('@/view/acl/roles')
      }
    ]
  },
  {
    path: '/ops',
    name: 'ops',
    component: Main,
    meta: {
      access: ['admin', 'groupadmin'],
      title: '运维',
      icon: 'ios-cog'
    },
    children: [
      {
        path: 'systeminfo',
        name: 'systeminfo',
        meta: {
          icon: 'md-pie',
          title: '系统信息'
        },
        component: () => import('@/view/ops/system-info.vue')
      },
      {
        path: 'systemlogs',
        name: 'systemlogs',
        meta: {
          icon: 'md-document',
          title: '系统日志'
        },
        component: () => import('@/view/ops/system-logs.vue')
      }
    ]
  },
  {
    path: '/message',
    name: 'message',
    component: Main,
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    children: [
      {
        path: 'message_page',
        name: 'message_page',
        meta: {
          icon: 'md-notifications',
          title: '消息中心'
        },
        component: () => import('@/view/single-page/message/index.vue')
      }
    ]
  },
  {
    path: '/error_logger',
    name: 'error_logger',
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: 'error_logger_page',
        name: 'error_logger_page',
        meta: {
          icon: 'ios-bug',
          title: '错误收集'
        },
        component: () => import('@/view/single-page/webadmin-errorlog.vue')
      }
    ]
  },
  {
    path: '/argu',
    name: 'argu',
    meta: {
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: 'params/:id',
        name: 'params',
        meta: {
          icon: 'md-flower',
          title: route => `{{ params }}-${route.params.id}`,
          notCache: true,
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/argu-page/params.vue')
      },
      {
        path: 'query',
        name: 'query',
        meta: {
          icon: 'md-flower',
          title: route => `{{ query }}-${route.query.id}`,
          notCache: true
        },
        component: () => import('@/view/argu-page/query.vue')
      }
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '/leech',
    name: 'leech',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/single-page/leech-calculator.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
